
import { ref, shallowRef } from '@vue/composition-api';
import { defineComponent, useContext, useMeta, useRoute, useRouter } from '@nuxtjs/composition-api';
import { Note, StatusBlock } from '05-ui-kit';
import scrollIntoView from 'smooth-scroll-into-view-if-needed';
import Tooltip from '05-ui-kit/lib/Tooltip';
import link from '~/helper/canonical';
import TSHybridPagination from '~/components/ts-components/TSHybridPagination/TSHybridPagination.vue';
import type { ProductExtended } from '~/type/product/Product';
import wrapFunc from '~/helper/wrapFunc';
import type { Comment as CommentType, Reaction } from '~/type/Comment';
import type { Review as ReviewType } from '~/type/Review';
import ReviewMobile from '~/components/review-component/Review/ReviewMobile.vue';
import ReviewComment from '~/components/review-component/ReviewComment/ReviewComment.vue';
import ReviewRating from '~/components/review-component/ReviewRating/ReviewRating.vue';
import Review from '~/components/review-component/Review/Review.vue';
import Comment from '~/components/review-component/Comment/Comment.vue';
import type { ResponseError } from '~/type/Error';
import { useReportStore } from '~/store/modal/report';
const __sfc_main = defineComponent({
  head: {}
});
__sfc_main.props = {
  response: {
    key: "response",
    required: true,
    type: Object
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const route = useRoute();
  const context = useContext();
  const router = useRouter();
  const list = ref<ReviewType[]>([]);
  const reviewWrap = shallowRef<HTMLDivElement>();
  const {
    enableReport
  } = useReportStore();
  const params = ref({
    id: props.response.product?.id,
    size: 7,
    sort: route.value.query?.sort
  });
  useMeta(() => ({
    title: `Отзывы на ${props.response.product?.name} от покупателей 05 ${props.response.product?.code}`,
    meta: [{
      hid: 'description',
      name: 'description',
      content: `${props.response.product?.name}: отзывы покупателей на 05 ✔ На данной странице вы узнаете о всех достоинствах и недостатках ${props.response.product?.name} ${props.response.product?.code}`
    }, ...(props.response.product?.metaRobot?.review ? [] : [{
      name: 'robots',
      content: 'noindex'
    }])],
    ...link({
      exclude: [],
      data: {
        route,
        config: context.$config
      }
    })
  }));
  function changeQuery(data: string) {
    router.push({
      query: {
        ...route.value.query,
        sort: data
      }
    });
  }
  function recalculateLikes({
    send,
    data,
    param,
    param2
  }: {
    send: () => Promise<void>;
    data: CommentType;
    param: 'like' | 'dislike';
    param2: 'like' | 'dislike';
  }) {
    /**
    * Устанавливает количество лайков/дизлайков и также их активность
    */
    const reaction = (data[param] as Reaction);
    const oppositeReaction = (data[param2] as Reaction);
    reaction.count = reaction.active ? reaction.count - 1 : reaction.count + 1;
    reaction.active = !reaction.active;
    if (reaction.active && oppositeReaction.active) {
      oppositeReaction.count = oppositeReaction.count - 1;
      oppositeReaction.active = false;
    }
    send();
  }
  function onScrollTop() {
    if (reviewWrap.value) {
      scrollIntoView(reviewWrap.value, {
        block: 'start'
      });
    }
  }
  function onError({
    response
  }: {
    response: {
      error: ResponseError;
    };
  }) {
    Tooltip({
      title: response?.error?.description ?? 'Ошибка при отправке комментария, попробуйте позже',
      description: '',
      type: 'error',
      mobileOffset: [5, 5, 63, 5]
    });
  }
  function onSuccessAddedComment({
    toggleShow
  }: {
    toggleShow: () => Promise<void>;
  }) {
    Tooltip({
      type: 'success',
      title: 'Комментарий отправлен на модерацию!',
      description: '',
      mobileOffset: [5, 5, 63, 5]
    });
    toggleShow();
  }
  return {
    wrapFunc,
    list,
    reviewWrap,
    enableReport,
    params,
    changeQuery,
    recalculateLikes,
    onScrollTop,
    onError,
    onSuccessAddedComment
  };
};
__sfc_main.components = Object.assign({
  StatusBlock,
  Note,
  ReviewRating,
  Review,
  ReviewComment,
  Comment,
  ReviewMobile,
  TSHybridPagination
}, __sfc_main.components);
export default __sfc_main;
